import { useTranslations } from 'next-intl';
import { Image } from 'components/image';
import { CatHeading } from 'components/blocks-components';
import { SELECT_OR_ADD_EQUIPMENT } from '../../../../_constants/constants';
import styles from '../../customer-account.module.scss';
import { NoActiveEquipmentMobile } from '../no-active-equipment-mobile';

export const NoActiveEquipment = () => {
  const t = useTranslations();
  const { src, width, height, alt } = SELECT_OR_ADD_EQUIPMENT;
  return (
    <>
      <div className=" d-none d-blg-block">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Image src={src} alt={alt} width={width} height={height} />
          <CatHeading variant="label-lg" className="my-3">
            <span className="color-black">{t('ADD_SELECT_EQP')}</span>
          </CatHeading>
          <div className={styles['my-equipment--no-equipment-text']}>
            <CatHeading variant="body-sm">{t('ADD_SELECT_EQP_MSG')}</CatHeading>
          </div>
        </div>
      </div>
      <div className="d-blg-none d-md-block">
        <NoActiveEquipmentMobile hasEquipments />
      </div>
    </>
  );
};
